import React from "react";
import { Navigate } from "react-router-dom";

const isMainDomain = () => {
  const hostname = window.location.hostname;
  const mainDomain = process.env.REACT_APP_MAIN_DOMAIN || 'preprod.dastaan.info';
  return hostname === mainDomain || process.env.REACT_APP_DOMAIN === 'main';
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("dastaan__token");
  const skipped = sessionStorage.getItem('dastaan__login_skipped') === 'true';

  // Allow access if: has token, is on main domain, or user explicitly skipped login
  if (!token && !isMainDomain() && !skipped) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
